class ExtendSectionInit {
  constructor() {
    this._ticking = false;
    this._resizeTimer = null;
    this._modules = {};
    let moduleClasses = {
      global:
        typeof ExtendSectionGlobal !== "undefined" ? ExtendSectionGlobal : null,
      about:
        typeof ExtendSectionAbout !== "undefined" ? ExtendSectionAbout : null,
      guide:
        typeof ExtendSectionGuide !== "undefined" ? ExtendSectionGuide : null,
      home: typeof ExtendSectionHome !== "undefined" ? ExtendSectionHome : null,
      homeV3:
        typeof ExtendSectionHomeV3 !== "undefined" ? ExtendSectionHomeV3 : null,
      s1: typeof ExtendSectionS1 !== "undefined" ? ExtendSectionS1 : null,
      s1v3: typeof ExtendSectionS1V3 !== "undefined" ? ExtendSectionS1V3 : null,
      s2: typeof ExtendSectionS2 !== "undefined" ? ExtendSectionS2 : null,
      s2pre:
        typeof ExtendSectionS2Pre !== "undefined" ? ExtendSectionS2Pre : null,
      s1lp1:
        typeof ExtendSectionS1LP1 !== "undefined" ? ExtendSectionS1LP1 : null,
      s1lp1u2:
        typeof ExtendSectionS1LP1U2 !== "undefined"
          ? ExtendSectionS1LP1U2
          : null,
      s1lp2:
        typeof ExtendSectionS1LP2 !== "undefined" ? ExtendSectionS1LP2 : null,
      s1lp3:
        typeof ExtendSectionS1LP3 !== "undefined" ? ExtendSectionS1LP3 : null,
      s1lp4:
        typeof ExtendSectionS1LP4 !== "undefined" ? ExtendSectionS1LP4 : null,
      t3product:
        typeof ExtendSectionT3Product !== "undefined"
          ? ExtendSectionT3Product
          : null,
      t3muse:
        typeof ExtendSectionT3Muse !== "undefined" ? ExtendSectionT3Muse : null,
      t3museDev:
        typeof ExtendSectionT3MuseDev !== "undefined" ? ExtendSectionT3MuseDev : null,
    };
    for (var name in moduleClasses) {
      if (!Object.prototype.hasOwnProperty.call(moduleClasses, name)) continue;

      if (typeof moduleClasses[name] !== "function") {
        console.warn("[ExtendSection] 模块未加载：" + name);
        continue;
      }

      try {
        this._modules[name] = new moduleClasses[name]();
      } catch (error) {
        console.warn("[ExtendSection] 模块初始化失败：" + name, error);
      }
    }
  }

  init() {
    const path = window.location.pathname;
    const pageType = window.ExtendPageType;
    // 全局始终初始化
    this._modules.global.init();
    if (pageType == "index") {
      this._modules.home.init();
      this._modules.homeV3.init();
    }
    if (pageType == "product") {
      this._modules.s1.init();
      this._modules.s1v3.init();
      this._modules.s2.init();
      this._modules.homeV3.productInit();
      this._modules.t3product.init();
      this._modules.t3muse.init();
      this._modules.t3museDev.init();
    }
    if (pageType == "page") {
      this._modules.about.init();
      this._modules.guide.init();
      this._modules.s1lp1.init();
      this._modules.s1lp1u2.init();
      this._modules.s1lp2.init();
      this._modules.s1lp3.init();
      this._modules.s1lp4.init();
      this._modules.s2pre.init();
    }
    if (path.includes("pages/start") || path.includes("pages/links")) {
      this._modules.global.scrollToHash($("#PageContainer"));
    }

    // 统一绑定 scroll
    this._bindScroll();
    // 统一绑定 resize
    this._bindResize();
  }

  _bindScroll() {
    window.addEventListener(
      "scroll",
      () => {
        if (!this._ticking) {
          requestAnimationFrame(() => {
            this._onScroll();
            this._ticking = false;
          });
          this._ticking = true;
        }
      },
      { passive: true }
    );
  }

  _bindResize() {
    window.addEventListener("resize", () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => {
        this._onResize();
      }, 150);
    });
  }

  _onScroll() {
    Object.values(this._modules).forEach((m) => {
      typeof m.onScroll === "function" && m.onScroll();
    });
  }

  _onResize() {
    Object.values(this._modules).forEach((m) => {
      typeof m.onResize === "function" && m.onResize();
    });
  }
}

// 启动
const ExtendDebounce = function () {
  let _timer;
  return (fn, delay) => {
    _timer && clearTimeout(_timer);
    return function () {
      const args = arguments;
      _timer = setTimeout(() => fn.apply(null, args), delay || 200);
    };
  };
};

$(document).ready(function () {
  window.ExtendHisongTheme = new ExtendSectionInit();
  console.log("ExtendHisongTheme creation successful");
  try {
    window.ExtendHisongTheme.init();
    document.dispatchEvent(new CustomEvent("ExtendHisongThemeReady"));
    console.log(
      "ExtendHisongTheme initialization successful",
      window.ExtendHisongTheme
    );
  } catch (error) {
    console.warn("ExtendHisongTheme 初始化失败：", error);
  }
});
